import { ofType } from "redux-observable";
import { EMPTY, of } from "rxjs";
import { switchMap, switchMapTo } from "rxjs/operators";
import { selectBalloonRemainingTime, selectBalloonRemainingTimeWithBuff, } from "../../../selectors/selectBalloonInfo";
import { selectIsModalOpen } from "../../../selectors/selectModalTabId";
import { utilTick } from "../../../utils/utilTick";
import { utilTime } from "../../../utils/utilTime";
import { actionBalloonInfoRequest, TypeActionBalloonInfo, } from "../../info/balloon/actionBalloonInfo";
import { IdModal } from "../../modals/IdModal";
export var epicTimeBalloonOffer = function (action$, state$) {
    return action$.pipe(ofType(TypeActionBalloonInfo.Received), switchMapTo(utilTick.second$), switchMap(function () {
        var state = state$.value;
        var timestamp = selectBalloonRemainingTime(state);
        var timestampWithBuff = selectBalloonRemainingTimeWithBuff(state);
        if (timestamp != undefined) {
            var isBalloonOfferOpen = selectIsModalOpen(state, IdModal.BalloonOffer);
            var secondsLeft = isBalloonOfferOpen
                ? utilTime.secondsLeftTill(timestampWithBuff)
                : utilTime.secondsLeftTill(timestamp);
            if (secondsLeft < 0) {
                return of(actionBalloonInfoRequest());
            }
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/time/epics/epicTimeBalloonOffer.ts
// module id = 2430
// module chunks = 3